import { em } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: grid;
  color: ${p => p.theme.colors.white};
  margin-bottom: ${em(40)};
  padding: 0 ${p => p.theme.indents.baseIndentXs};
  grid-template-areas:
    'difference'
    'wgs'
    'dna';

  ${p => p.theme.mq.upMd} {
    grid-template-columns: 1fr;
    margin-bottom: ${p => (p.isLast ? em(100) : em(135))};
    padding: 0 ${p => p.theme.indents.baseIndentMd};
  }
`

export const DifferenceBox = styled.div`
  grid-area: difference;
  margin-bottom: ${em(40)};

  ${p => p.theme.mq.upMd} {
    margin-bottom: ${em(60)};
  }
`

export const DifferenceInner = styled.div`
  width: ${em(260)};
  padding-top: ${em(30)};

  ${p => p.theme.mq.upMd} {
    padding-top: 0;
    width: ${em(305)};
  }
`

export const Diff = styled.div`
  color: ${p => p.theme.colors.purpleHeart};
  font-size: ${em(60)};
`
